/**
 * Convert a message and role to a message object
 *
 * @param message {string} - The message to convert
 * @param role {string} - The role of the message
 * @returns {{role, message}|null}
 */
const ToMessage = (message, role) => {
    if (message === null || message === undefined) {
        return null;
    }

    return {
        content: message,
        role: role
    }
}

export default ToMessage;